import React, { memo } from "react";
import LabeledInput, {
  CommonLabeledInputProps,
  CommonLabeledInputElementProps,
} from "../labeledInput";
import XGSInput, { XGSInputBaseProps } from "../../../xgs-input/xgsInput";
import infoTextIcon from "../../../../images/info_blue_filled.svg"
import "./labeledTextInput.scss";

export interface LabeledTextInputProps
  extends CommonLabeledInputElementProps,
    CommonLabeledInputProps,
    React.HTMLProps<HTMLInputElement>,
    XGSInputBaseProps {
  isLoading?: boolean;
  hasCustomError?: boolean;
  infotext?: string;
}

const LabeledTextInput: React.FC<LabeledTextInputProps> = memo(({
  label,
  required,
  labelMode,
  requiredAsteriskDisabled,
  fields,
  meta,
  readonly,
  error,
  hasCustomError,
  className,
  ...props
}) => {
  const isFailed = (): boolean => {
    return (meta?.touched && meta?.error) || error || hasCustomError ? true : false;
  };
  return (
    <LabeledInput
      label={label}
      labelMode={labelMode}
      required={required}
      requiredAsteriskDisabled={requiredAsteriskDisabled}
      isFailed={isFailed}
      error={meta?.error || error}
      className={className || ''}
    >
      <XGSInput
        isFailed={isFailed}
        {...fields}
        readOnly={readonly}
        {...props}
      />
      {props.infotext &&
      <div className="info-text-container">
            <img src={infoTextIcon} alt="info-text-icon"/>
           <small className="info-text">{props.infotext}</small>
      </div>
      }
    </LabeledInput>
  );
});

export default LabeledTextInput;
